var _defs, _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29 11h-18v18h18z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #83b797 } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m20 40c11 0 20-9 20-20 0-11-9-20-20-20-11 0-20 9-20 20 0 11 9 20 20 20z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m28.9 29h-5.3l-4.9-7.1-6.1 7.1h-1.6l7-8.1-7-10.2h5.3l4.7 6.7 5.8-6.7h1.5l-6.6 7.7zm-9.5-8l4.9 6.9h2.4l-5.9-8.5-0.7-1-4.6-6.5h-2.4l5.6 8.1 0.7 1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram1);
export default __webpack_public_path__ + "static/media/instagram1.9515abeca12cfa99ffb88cb6f07c7998.svg";
export { ForwardRef as ReactComponent };